<nz-carousel
  nzEffect="scrollx"
  #carouselRef
  [nzDots]="false"
  style="width: 100%; position: absolute; top: 40%; left: 0%; height: 100%; min-height: 160px;"
>
  <div *ngFor="let card of carouselList" nz-carousel-content style="text-align: center; overflow: hidden;">
    <div
      class="card"
      style="width: 100%; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); border-radius: 8px; background: white; display: flex; flex-direction: column; max-height: 300px;"
    >
      <!-- Card Header (Image) -->
      <div class="card-header" style="width: 100%; border-radius: 8px 8px 0 0; overflow: hidden; max-height: 250px;">
        <img
          *ngIf="card.mediaUrl || card.thumbnailUrl"
          [src]=" card.thumbnailUrl || card.mediaUrl"
          alt="Uploaded media"
          style="height: 200px; width: 100%; object-fit: fill;"
        />
      </div>

      <!-- Card Content -->
      <div class="card-content" style="padding: 16px; text-align: center;">
        <div class="card-title" style="font-size: 18px; font-weight: bold; margin-bottom: 8px; color: #333;">
          {{ card.cardTitle || 'Card Title' }}
        </div>
        <p class="card-description" style="font-size: 14px; color: #6c6b6b; line-height: 1.4; margin-bottom: 12px;">
          {{ card.cardDescription || 'Card Description' }}
        </p>

        <!-- Suggestions -->
        <div *ngIf="card.suggestions?.length > 0" style="display: flex; justify-content: center; flex-wrap: wrap;">
          <ng-container *ngFor="let suggestion of card.suggestions">
            <div *ngIf="suggestion.displayText" style="margin: 5px;">
              <a
                nz-button
                nzType="link"
                target="_blank"
                style="color: #007bff; font-size: 14px;"
              >
                <span
                  nz-icon
                  [nzType]="getSuggestionIcon(suggestion.suggestionType)"
                  nzTheme="outline"
                ></span>
                {{ suggestion.displayText }}
              </a>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</nz-carousel>

<!-- Carousel Controls -->
<div
  
  style="display: flex; justify-content: space-between; gap: 16px; margin-top: 95%;"
>
  <button nz-button nzType="link" (click)="prevCard()" nzShape="circle" style="color: black; background-color: aliceblue;  opacity: 0.2;">
    <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
  </button>
  <button nz-button nzType="link" (click)="nextCard()" nzShape="circle" style="color: black; background-color: aliceblue; opacity: 0.2;">
    <span nz-icon nzType="arrow-left" nzTheme="outline" style="transform: rotate(180deg);"></span>
  </button>
</div>
